import React, { useCallback } from "react";
// import HamburgerButton from "./HamburgerButton";
import { processEnvServer } from "@RHCommerceDev/hooks/useSsrHooks";
import { Theme, useMediaQuery } from "@mui/material";
import { getReqContext } from "@RHCommerceDev/utils/reqContext";
import { getSelectorsByUserAgent } from "react-device-detect";
import { useHeaderAtom } from "hooks/atoms/useHeaderAtom";
import HamburgerButton from "./HamburgerButton";

export const HamburgerButtonContainer = () => {
  // On SSR, detect if device is mobile from user-agent and set `mobile` flag.
  const req = getReqContext();
  let mobile = false;
  const userAgentSSR = req && req?.headers["user-agent"];
  if (userAgentSSR) {
    const { isMobile } = getSelectorsByUserAgent(userAgentSSR);
    mobile = !!isMobile;
  }

  //On CSR, Check if viewport is ≥ "md"
  const mdUp = useMediaQuery<Theme>(theme => theme.breakpoints.up("md"), {
    noSsr: !processEnvServer
  });

  const isLargeDevice = processEnvServer ? !mobile : mdUp;

  const {
    state: headerState,
    openHamburgerDropdown,
    closeHamburgerDropdown
  } = useHeaderAtom();
  const isHamburgerDropdownOpen = headerState.isHamburgerDropdownOpen;

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      //e.stopPropagation =>  Stop click away effect from closing the category dropdown.
      // Ensures this button toggles the hamburger dropdown instead.
      e.stopPropagation();
      const target = e.target as HTMLButtonElement;
      if (isHamburgerDropdownOpen) {
        closeHamburgerDropdown();
      } else {
        if(isLargeDevice) {
          document?.body?.dispatchEvent(
          new CustomEvent("cta_click", {
            detail: {
              item: {
                isHamburgerMenuOpened: true,
                iconName: "Hamburger Icon",
                navigationName: "Navigation/HamburgerMenu",
                class: target?.className,
                id: target?.id 
              }
            }
          })
        );
        }
        openHamburgerDropdown();
      }
    },
    [openHamburgerDropdown, closeHamburgerDropdown, isHamburgerDropdownOpen]
  );

  return (
    <HamburgerButton
      isOpen={isLargeDevice && isHamburgerDropdownOpen}
      onClick={handleClick}
    />
  );
};
